<template>
  <div id="log-detail" v-if="detail.id > 0">
    <table class="unstriped">
      <tbody>
      <tr>
        <td>{{ 'Date'|t }}:</td>
        <td>{{ detail.timestamp|timestamp }}</td>
      </tr>
      <tr>
      <td>{{ 'Session'|t }}:</td>
      <td>{{ detail.session }}</td>
      </tr>
      <tr>
        <td>{{ 'Hostname'|t }}:</td>
        <td>{{ detail.hostname }}</td>
      </tr>
    <tr>
    <td>{{ 'Registrar'|t }}:</td>
    <td>{{ detail.registrar }}</td>
    </tr>
      <tr>
        <td>{{ 'Client transaction ID'|t }}:</td>
        <td>{{ detail.client_trid }}</td>
      </tr>
      <tr>
        <td>{{ 'Command'|t }}:</td>
        <td>{{ detail.command }}</td>
      </tr>
      <tr>
        <td>{{ 'Subject'|t }}:</td>
        <td>{{ detail.object }}</td>
      </tr>
      <tr>
        <td>{{ 'Duration'|t }}:</td>
        <td>{{ formatMilliSeconds(detail.duration) }}</td>
      </tr>
      <tr>
        <td>{{ 'Response code'|t }}:</td>
        <td>{{ detail.code }}</td>
      </tr>
      <tr>
        <td>{{ 'Message'|t }}:</td>
        <td>{{ detail.message }}</td>
      </tr>
      <tr>
        <td>{{ 'Request size'|t }}:</td>
        <td>{{ formatBytes(detail.request_size) }}</td>
      </tr>
      <tr>
        <td>{{ 'Request body'|t }}:</td>
        <td><pre>{{ detail.request }}</pre></td>
      </tr>
      <tr>
        <td>{{ 'Response size'|t }}:</td>
        <td>{{ formatBytes(detail.response_size) }}</td>
      </tr>
      <tr>
        <td>{{ 'Response body'|t }}:</td>
        <td><pre>{{ detail.response }}</pre></td>
      </tr>
      </tbody>
    </table>

  </div>
</template>
<script>
  import api from '@/api';

  export default {
    name: 'Detail',
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        detail: {
          id: 0
        }
      }
    },
    created() {
      api.viewLog(
        {id: this.id},
        data => this.detail = data
      )
    },
    methods: {
      formatMilliSeconds: function (n, round) {
        if (n === 0) {
          return "0 ms"
        }

        if (n < 1000000) {
          if (round) {
            return Math.round((n / 1000) * 100) / 100 + " μs"
          } else {
            return (n / 1000) + " μs"
          }
        }

        if (round) {
          return Math.round((n / 1000000) * 100) / 100 + " ms"
        } else {
          return (n / 1000000) + " ms"
        }
      },
      formatBytes: function (n) {
        return Math.round((n / 1024) * 100) / 100 + " kB"
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/log/Detail.vue